module.exports = __webpack_public_path__ + "static/media/SaoPaulo_kmeans_202_500.40269ab3.csv";